import { useContext } from "react";
import { RootWidthContext } from "../rootWidth/index.js";
const useIsInsideContainer = ()=>{
    const rootWidth = useContext(RootWidthContext);
    return 'number' == typeof rootWidth;
};
export { useIsInsideContainer };
